<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full text-center">
      <h1 class="text-9xl font-bold text-primary">404</h1>
      <p class="mt-3 text-xl text-gray-600">页面未找到</p>
      <p class="mt-2 text-gray-500">您访问的页面不存在或已被移除</p>
      <div class="mt-6">
        <router-link to="/" class="btn btn-primary inline-flex"> 返回首页 </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
